import React from "react";
import {bool, node, string} from 'prop-types'
import {useFormContext} from "react-hook-form";

import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {Stack} from "@bedrock-layout/stack";
import { ErrorMessage } from '@hookform/error-message';
import {Box, Text} from "theme-ui";
import _ from "lodash";
import {useHistory, useParams} from "react-router";


function Wysiwig({name, label, disabled = false}) {
    const history = useHistory();
    const {getValues, setValue, formState} = useFormContext()
    const error = _.get(formState.errors, name)
    const errorMsg = error && error.message
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline"],
            ['link'],
            [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }], 
            [{ list:  "ordered" }, { list:  "bullet" }], 
            [{ indent:  "-1" }, { indent:  "+1" }],
            ['clean'],
        ]
    }

    const variant = (error)
        ? 'wysiwig.error'
        : disabled
            ? 'wysiwig.disabled'
            : 'wysiwig'

    return (
        <Stack gutter="lg">
            {label && <Text variant="label">{label}</Text>}
            <Box variant={variant}>
                <ReactQuill
                    modules={modules}
                    theme="snow"
                    value={getValues(name)}
                    onChange={d => {setValue(name, d)}}
                />
            </Box>
            {error && error.message && errorMsg.length > 0 &&
            <Text color={errorMsg ? 'errorText' : null}>{errorMsg}</Text>}
        </Stack>
    );
}

Wysiwig.propTypes = {
    children: node,
    label: string,
    name: string.isRequired,
    disabled: bool
}

export default Wysiwig
